import { createRouter, createWebHistory } from 'vue-router'

const GuideHub = () => import('@/views/GuideHub.vue')
const SalesGuide = () => import('@/views/SalesGuide.vue')
const OperatorGuide = () => import('@/views/OperatorGuide.vue')
const ProductIntro = () => import('@/views/ProductIntro.vue')
const TechPanorama = () => import('@/views/TechPanorama.vue')
const BigScreen = () => import('@/views/BigScreen.vue')
const OperationScreen = () => import('@/views/OperationScreen.vue')

const routes = [
  { path: '/guide', name: 'GuideHub', component: GuideHub, meta: { public: true } },
  { path: '/guide/product-intro', name: 'ProductIntro', component: ProductIntro, meta: { public: true } },
  { path: '/demo/tech-panorama', name: 'TechPanorama', component: TechPanorama, meta: { public: true } },
  { path: '/big-screen', name: 'BigScreen', component: BigScreen, meta: { public: true } },
  { path: '/operation-screen', name: 'OperationScreen', component: OperationScreen, meta: { public: true } },
  { path: '/sales-guide', name: 'SalesGuide', component: SalesGuide, meta: { public: true } },
  { path: '/operator-guide', name: 'OperatorGuide', component: OperatorGuide, meta: { public: true } },
  {
    path: '/',
    name: 'PortalLayout',
    component: () => import('@/views/PortalLayout.vue'),
    meta: { public: true },
    children: [
      {
        path: '',
        name: 'PortalHome',
        component: () => import('@/views/PortalHome.vue'),
        meta: { public: true },
      },
      {
        path: 'capabilities',
        name: 'PortalCapabilities',
        component: () => import('@/views/PortalCapabilities.vue'),
        meta: { public: true },
      },
      {
        path: 'scenarios',
        name: 'PortalScenarios',
        component: () => import('@/views/PortalScenarios.vue'),
        meta: { public: true },
      },
      {
        path: 'agents',
        name: 'PortalAgentsPreview',
        component: () => import('@/views/PortalAgentsPreview.vue'),
        meta: { public: true },
      },
    ],
  },
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
})

export default router
